import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED, EMAIL } = validators;
    const errors = {};
    if (REQUIRED(values.email)) {
        errors.email = 'Please enter your email address';
    }
    if (EMAIL(values.email)) {
        errors.email = 'Please enter a valid email address';
    }
    if (REQUIRED(values.name)) {
        errors.name = 'Please enter a name';
    }
    if (values.name && values.name.length < 3) {
        errors.name = 'Must be 3 characters or more';
    }
    if (REQUIRED(values.roleId)) {
        errors.roleId = 'Please select a role';
    }
    if (REQUIRED(values.entityType)) {
        errors.entityType = 'Please select a User Level';
    }
    if (REQUIRED(values.entityId)) {
        errors.entityId = 'Please select a Entity';
    }
    if (REQUIRED(values.uLevel)) {
        errors.uLevel = 'Please select user level';
    }

    if(values.uLevel && !values.supervisor){
        errors.supervisor = 'Please select a supervisor'
    }

    return errors;
};

export default validate;
